module.exports = __webpack_public_path__ + "img/1d22f3e41d284f50b2c8fc32e0788698.e7137955.jpeg";